import { createStore } from 'vuex';
import io from 'socket.io-client';

function getToken() {
  return localStorage.getItem('token') || '';
}

const socket = io(process.env.VUE_APP_SOCKET_URL || 'http://localhost:4000', {
  auth: () => ({ token: getToken() }),
});

export default createStore({
  state: {
    hasPoint: 1000,
    users: null,
    messages: [],
    socket,
    gameResults: [], // {round,value,parity,side,created_at}
    currentUser: null,
  },
  getters: {},
  mutations: {
    bet(state) {
      Math.floor(Math.random() * 2) == 0 ? (state.hasPoint *= 2) : (state.hasPoint /= 2);
      // console.log(state.hasPoint);
    },
    setUsers(state, users) {
      state.users = users;
      if (users) {
        state.currentUser = {
          ...users,
          _id: users._id || users.id,
        };
      }
    },
    sendMessage(state, message) {
      if (!state.currentUser) {
        return;
      }
      state.socket.auth = { token: getToken() };

      const messageData = {
        message: message,
        token: getToken(),
      };

      state.socket.emit('chat message', messageData);
      // 임시 push 코드 삭제 완료
    },
    onMessage(state) {
      // 기존 이벤트 리스너 제거
      state.socket.off('chat message');
      state.socket.off('game history');
      state.socket.off('game result');

      state.socket.on('chat message', (msg) => {
        // 중복 메시지 방지
        const isDuplicate = state.messages.some((m) => m.id === msg.id);
        if (!isDuplicate) {
          state.messages.push(msg);
        }
      });
      // 서버에서 전송되는 게임 결과
      state.socket.on('game result', (res) => {
        const parity = res.parity || (res.value % 2 === 0 ? '짝' : '홀');
        const side = res.side || (res.value <= 4 ? '좌' : '우');
        state.gameResults.unshift({ ...res, parity, side });
        if (state.gameResults.length > 100) {
          state.gameResults.pop();
        }
      });
    },
    setMessages(state, list) {
      const normalized = (list || []).map((m) => ({
        id: m._id || m.id,
        message: m.message,
        senderId: m.senderId || m.sender_id || m.sender,
        senderName: m.senderName,
        timestamp: m.timestamp,
      }));
      // 최근이 아래로 쌓이도록 시간 오름차순 정렬
      normalized.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
      state.messages = normalized;
    },
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    mountGame(state, gameRes) {
      // 정규화 + 상한 100 유지
      const normalized = (gameRes || [])
        .map((r) => ({
          ...r,
          parity: r.parity || (r.value % 2 === 0 ? '짝' : '홀'),
          side: r.side || (r.value <= 4 ? '좌' : '우'),
        }))
        .slice(0, 100);
      state.gameResults = normalized;
    },
  },
  actions: {},
  modules: {},
});
